import React from 'react';
import AniLink from 'gatsby-plugin-transition-link/AniLink';

import shortid from 'shortid';
import PropTypes from 'prop-types';

const TelecommunicationSection = ({
  telecomSectionData: { title, description, list, listHeader, btnText },
  versionBg
}) => {
  const firstPart = list.slice(0, 5);
  const secondPart = list.slice(5);
  const longList = list.length > 4;

  return (
    <div className={`telecommunication text-format ${versionBg && 'withBg'}`}>
      <div className="container my-4">
        <div className="softwares">
          <div className="row ">
            <div className={`col-lg-12 ${versionBg && 'pseudo-bg'}`}>
              <div className="col col-md-10 px-0">
                <h2
                  className="subtitle bigger"
                  style={{ paddingBottom: '30px' }}
                >
                  {title}
                </h2>
              </div>
              <div className="industries-details">
                <div className="industries-text">
                  {description.map(el => (
                    <p key={shortid.generate()}>{el}</p>
                  ))}
                  <AniLink
                    cover
                    bg="#EAEBF1"
                    to="/contact/"
                    className="btn btn-main narrow my-4"
                  >
                    {btnText}
                  </AniLink>
                </div>
                <div className="industries-category">
                  {versionBg && (
                    <div className="industries-category-header">
                      {listHeader}
                    </div>
                  )}
                  <div
                    className="industries-list"
                    style={{ paddingTop: '20px', maxWidth: '21rem' }}
                  >
                    {!longList ? (
                      <div>
                        <ul>
                          {list.map(el => (
                            <li key={shortid.generate()}>{el}</li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <>
                        <div>
                          <ul>
                            {firstPart.map(el => (
                              <li key={shortid.generate()}>{el}</li>
                            ))}
                          </ul>
                        </div>
                        <div>
                          <ul>
                            {secondPart.map(el => (
                              <li key={shortid.generate()}>{el}</li>
                            ))}
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TelecommunicationSection;

TelecommunicationSection.propTypes = {
  telecomSectionData: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.array,
    list: PropTypes.array,
    btnText: PropTypes.string
  }).isRequired
};
